import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import FileBase64 from "../../components/Upload/UploadFile";
import { dealerCashLiftingList } from "../../redux/actions/dealerCashLiftingListAction";
import { dealerReqCashLifting } from "../../redux/actions/dealerReqCashLiftingAction";
import { dealerBankName } from "../../redux/actions/dealerBankNameAction";
import { dealerBranchName } from "../../redux/actions/dealerBranchNameAction";
import { dealerAccountNumber } from "../../redux/actions/dealerAccountNumberAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Util from "../../validation/index";
import CropOriginalIcon from '@mui/icons-material/CropOriginal';

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function DealerCashLifting() {
	const navigate = useHistory();
	const [addNotification, setAddNotification] = useState(false);
	const [editNotification, setEditNotification] = useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(true);
	const [addOpen, setAddOpen] = useState(false);

	const [cashLiftingListStatus, setCashLiftingListStatus] = useState(false);
	const [cashLiftingListArray, setCashLiftingListArray] = useState("");

	const [reqCashLiftingStatus, setReqCashLiftingStatus] = useState(false);
	const [reqCashLiftingArray, setReqCashLiftingArray] = useState("");

	const [show, setShow] = useState(false);
	const [imgModal, setImgModal] = useState("")
	const showModal = (slipImage) => {
		setShow(true);
		setImgModal(slipImage)

	}
	// console.log('cashLiftingListArray obj:', cashLiftingListArray.cashList.qrcode)
	// console.log('viewDsrDetailsArray obj: ', viewDsrDetailsArray.userMaster.base64UserPhotoFront);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [UploadFileName, setUploadFileName] = useState("");
	const [uploadFile, setUploadFile] = useState("");

	const [requestInput, setRequestInput] = useState({
		bankName: "",
		branchName: "",
		accountNum: "",
		amount: ""
	});

	const { bankName, branchName, accountNum, amount } = requestInput;

	const onInputChangeMod = ({ target: { name, value } }, type) => {
		const obj = {
			...requestInput
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			obj[name] = value
		}
		setRequestInput(obj);
	};

	const [user, setUser] = useState({
		bankNameSearch: "",
		branchNameSearch: ""
	});

	const { bankNameSearch, branchNameSearch } = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			obj[name] = value
		}
		setUser(obj);
	};
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const cashLiftingListRes = useSelector(
		({ dealerCashLiftingList }) => dealerCashLiftingList
	);

	const reqCashLiftingRes = useSelector(
		({ dealerReqCashLifting }) => dealerReqCashLifting
	);

	const bankNameRes = useSelector(({ dealerBankName }) => dealerBankName);

	const branchNameRes = useSelector(({ dealerBranchName }) => dealerBranchName);

	const accountNumberRes = useSelector(({ dealerAccountNumber }) => dealerAccountNumber);

	const handleAttachmentsDoc = (e, uploadFile) => {
		if (uploadFile == "uploadFile") {
			setUploadFile(e.base64);
			setUploadFileName(e.name);
		}
	};

	const cashLiftingListReq = () => {
		setCashLiftingListStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId,
				bankName: bankNameSearch.split(",")[1],
				branchName: branchNameSearch.split(",")[1]
			}
		};
		dispatch(dealerCashLiftingList(req, authToken));
	};


	const cashLiftingListFunc = () => {
		if (cashLiftingListStatus) {
			if (cashLiftingListRes.data.status == "sucess") {
				setCashLiftingListArray([].concat(cashLiftingListRes.data.cashList));
				setIsLoading(false);
			}
			if (cashLiftingListRes.data.status == "failed") {
				setCashLiftingListArray(cashLiftingListRes.data);
				setIsLoading(false);
				if (
					cashLiftingListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					cashLiftingListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		cashLiftingListFunc();
	}, [cashLiftingListRes.data.status]);


	useEffect(() => {
		if (cashLiftingListRes.data.status == "sucess") {
			setPage(0);
		}
	}, [cashLiftingListRes.data.status]);

	const reqCashLiftingReq = () => {
		setReqCashLiftingStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId,
				bankName: bankName.split(",")[1],
				branchName: branchName.split(",")[1],
				accountNumber: accountNum,
				amount: amount,
				qrCode: uploadFile.split(",")[1]
			}
		};
		dispatch(dealerReqCashLifting(req, authToken));
		setAddOpen(false);
	};

	const reqCashLiftingFunc = () => {
		if (reqCashLiftingStatus) {
			if (reqCashLiftingRes.success) {
				setReqCashLiftingArray(reqCashLiftingRes.data);
				setEditNotification(true);
				cashLiftingListReq();
			}
			if (reqCashLiftingRes.failed) {
				setReqCashLiftingArray(reqCashLiftingRes.data);
				setEditNotification(true);
			}
		}
	};

	useEffect(() => {
		reqCashLiftingFunc();
	}, [reqCashLiftingRes.data.status]);

	const bankNameReq = () => {
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId
			}
		};

		dispatch(dealerBankName(req, authToken));
	};

	const branchNameReq = () => {
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId,
				bankCode: bankName.split(",")[0] || bankNameSearch.split(",")[0]
			}
		};

		dispatch(dealerBranchName(req, authToken));
	};

	useEffect(() => {
		setUser({
			bankNameSearch: bankNameSearch,
			branchNameSearch: ""
		})
		setRequestInput({
			bankName: bankName,
			branchName: "",
			accountNum: "",
			amount: amount
		})
		if (bankName || bankNameSearch) {
			branchNameReq();
		}
	}, [bankName, bankNameSearch]);

	const accountNumberReq = () => {
		let req = {
			actionCustomerMasterRequestVO: {

				dealerId: regenerateTokenRes.data.partnerId,
				branchCode: branchName.split(",")[0],
				bankCode: bankName.split(",")[0]
			}
		}
		dispatch(dealerAccountNumber(req, authToken))
	}

	useEffect(() => {
		if (branchName && bankName) {
			accountNumberReq()
		}
	}, [branchName, bankName])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			cashLiftingListReq();
			bankNameReq();
		}
	}, [regenerateTokenRes.data.status]);



	const handleClose = () => {
		setAddOpen(false);
		setShow(false)
		setRequestInput({
			bankName: "",
			branchName: "",
			accountNum: "",
			amount: ""
		});
	};

	const openAdd = () => {
		setAddOpen(true);
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setAddNotification(false);
		setEditNotification(false)
		setRequestInput({
			bankName: "",
			branchName: "",
			accountNum: "",
			amount: ""
		});
	};

	useEffect(() => {
		console.log(bankName, "????????????????????????????????/")
	}, [bankName])

	// useEffect(() => {
	// 	console.log(reqCashLiftingRes.data.cashList, "/////////////////////////////////////////")
	// }, [reqCashLiftingRes])
	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px",
							textAlign: "center"
						}}
					>
						<Grid item xs={12} md={8} sm={3} lg={8}></Grid>
						<Grid item xs={12} md={4} sm={3} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => openAdd()}
							>
								Request Cash Lifting
							</CustomButton>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								label="Bank Name"
								fullWidth={true}
								name="bankNameSearch"
								defaultValue={bankNameSearch || ""}
								onChange={(e) => onInputChange(e, "")}
							>
								<MenuItem value="" selected="">
									Select Bank Name
								</MenuItem>
								{bankNameRes.success &&
									[]
										.concat(bankNameRes.data.list)
										.map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								label="Branch Name"
								fullWidth={true}
								name="branchNameSearch"
								defaultValue={branchNameSearch || ""}
								onChange={(e) => onInputChange(e, "")}
							>
								<MenuItem
									value=""
									selected=""
								>
									Select Branch Name
								</MenuItem>
								{branchNameRes.success &&
									[]
										.concat(branchNameRes.data.list)
										.map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={cashLiftingListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : cashLiftingListArray.length == undefined ||
					!cashLiftingListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Summary Data
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 themeBackground"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow className="themeBackground">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Request ID{" "}

												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Bank Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Branch Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Account Number
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Amount
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Slip Image
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Remark
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{cashLiftingListArray &&
												[]
													.concat(cashLiftingListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.transactionId}
															</TableCell>
															<TableCell align="center">
																{row.bankName}
															</TableCell>
															<TableCell align="center">{row.branchName}</TableCell>
															<TableCell align="center">
																{row.payMode}
															</TableCell>
															<TableCell align="center">{row.amount}</TableCell>
															<TableCell align="center">
																{row.qrcode ? <CropOriginalIcon style={{ cursor: 'pointer' }} onClick={() => showModal(row.qrcode)} /> : "-"}
																{/* {row.qrCode && <CropOriginalIcon style={{ cursor: 'pointer' }} onClick={showModal}></CropOriginalIcon> || "-"} */}
																{/* <img
																	src={`data:image/jpeg;base64,${row.qrcode}`}
																	style={{ maxWidth: "100%" }}
																/> */}

															</TableCell>
															<TableCell align="center">{row.status}</TableCell>
															<TableCell align="center">
																{row.statusDescription}
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(cashLiftingListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
			</Layout>

			<div>
				<Dialog open={addOpen} onClose={handleClose}>
					<DialogTitle>Request Cash Lifting</DialogTitle>
					<DialogContent>
						<TextField
							select
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Bank Name"
							fullWidth={true}
							name="bankName"
							defaultValue={bankName || ""}
							onChange={(e) => onInputChangeMod(e, "")}
						>
							<MenuItem value="" selected="">
								Select Bank Name
							</MenuItem>
							{bankNameRes.success &&
								[]
									.concat(bankNameRes.data.list)
									.map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
						</TextField>
						<TextField
							select
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Branch Name"
							fullWidth={true}
							name="branchName"
							defaultValue={branchName || ""}
							onChange={(e) => onInputChangeMod(e, "")}
						>
							<MenuItem
								value=""
								selected=""
							>
								Select Branch Name
							</MenuItem>
							{branchNameRes.success &&
								[]
									.concat(branchNameRes.data.list)
									.map((x) => <MenuItem value={x.code + "," + x.name}>{x.name}</MenuItem>)}
						</TextField>
						<TextField
							select
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Account Number"
							fullWidth={true}
							name="accountNum"
							defaultValue={accountNum || ""}
							onChange={(e) => onInputChangeMod(e)}
						>
							<MenuItem
								value=""
								selected=""
							>
								Select Account Number
							</MenuItem>
							{accountNumberRes.success &&
								[]
									.concat(accountNumberRes.data.list)
									.map((x) => <MenuItem value={x.code}>{x.code}</MenuItem>)}
						</TextField>
						<TextField
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="number"
							label="Amount"
							fullWidth={true}
							name="amount"
							value={amount || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
						<div style={{ marginTop: "1.5rem" }}>
							{" "}
							<Typography
								variant="body1"
								align="justify"
								gutterBottom={true}
								style={{ color: "#4f6c8d" }}
							>
								Upload Deposit Slip
							</Typography>
							<FileBase64
								multiple={false}
								name={false}
								id="documentGuard1"
								accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
								onDone={(e) => handleAttachmentsDoc(e, "uploadFile")}
								showUploadList={false}
								value={UploadFileName}
							/>
							{UploadFileName ? UploadFileName : ""}
						</div>
					</DialogContent>
					<DialogActions style={{ padding: "14px" }}>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={handleClose}
						>
							Cancel
						</CustomButton>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={reqCashLiftingReq}
						>
							Add
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>

			{reqCashLiftingRes.success && (
				<div>
					<Dialog open={editNotification} onClose={handleNoticationClose}>
						<DialogContent className="text-center lightThemeBackground">
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{reqCashLiftingRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{reqCashLiftingRes.failed && (
				<div>
					<Dialog open={editNotification} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{reqCashLiftingRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
			<div>
				<Dialog open={show} onClose={handleNoticationClose}>
					<DialogContent className="text-center lightThemeBackground">

						<img
							src={`data:image/jpeg;base64,${imgModal}`}
							style={{ maxWidth: "100%" }}
						/>


					</DialogContent>

					<DialogActions style={{ justifyContent: "center" }}>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={handleClose}
						>
							Close
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>
		</>
	);
}

export default DealerCashLifting;
